<template>
    <div class="form-check d-flex flex-column flex-md-row mt-3 mb-1 align-items-center">
        <span>
            <input
                :id="id"
                :name="name"
                :disabled="inputDiasables"
                v-model="current_value"
                value="true"
                class="form-check-input"
                type="checkbox"
            >
            <label class="form-check-label" :for="id">
                {{ textPrivacy }}
            </label>
        </span>
        <span v-if="modal">[<span class="click-modal" @click="openPrivacyModal">Leggi</span>]</span>

        <modal
            :name="name"
            :ref="name"
            extraClass="privacyModal"
        >
            <template slot="header">
                <span v-html="langPrivacy[modal].title"></span>
            </template>

            <template slot="body">
                <span v-html="langPrivacy[modal].content"></span>
            </template>

            <template slot="footer">
                <button class="btn btn-network btn-md" @click="closePrivacyModal">Ho letto</button>
            </template>
        </modal>
    </div>
</template>

<script>
import Tooltip from '../Tooltip'
import Modal from '../Modal'

export default {
    components: {
        'tooltip': Tooltip,
        'modal': Modal,
    },

    props: {
        id: {
            type: String,
            required: true,
        },

        name: {
            type: String,
            required: true,
        },

        textPrivacy: {
            type: String,
            required: true,
        },

        langPrivacy: {
            type: Object,
            required: true,
        },

        value: {
            type: Boolean,
            required: true,
        },

        modal: {
            type: String,
            required: false,
        }
    },

    data() {
        return {
            current_value: this.value,
            inputDiasables: true
        }
    },

    methods: {
        openPrivacyModal() {
            window.events.$emit('showModal', { name: this.name })
        },

        closePrivacyModal() {
            this.inputDiasables = false
            this.current_value = true
            window.events.$emit('hideModal', { name: this.name })
        },
    },

    computed: {
        // currentLang() {
        //     return this.lang
        // },
    },

    watch: {
        current_value() {
            this.$emit('input', this.current_value)
        },
    }
}
</script>

<style scoped>
    
</style>